import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutingHelperService} from '../../services/routing-helper.service';
import {RoutesEnums} from '../../enums/RoutesEnums';
import {BlogPostComponent} from './components/blog-post/blog-post.component';
import {BlogComponent} from './components/blog/blog.component';

const routes: Routes = [
  {
    matcher: (url) => {
      const posParams = RoutingHelperService.CreatePosParams(
        [RoutesEnums.TAG, 'id', 'tag'],
        url
      );
      return posParams ? {consumed: url, posParams} : null;
    },
    component: BlogComponent,
  },
  {
    matcher: (url) => {
      const posParams = RoutingHelperService.CreatePosParams(
        ['id', 'urlPath'],
        url
      );
      return posParams ? {consumed: url, posParams} : null;
    },
    component: BlogPostComponent,
  },
  {path: '', component: BlogComponent},
  {path: '**', component: BlogComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlogRoutingModule {}

export const blogRoutingComponents = [BlogComponent];
